<template>
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-card class="elevation-6">
                            <v-card-text>
                                <v-card-title> <h2> Σύνδεση  </h2></v-card-title>
                                <v-spacer></v-spacer>
                                <v-form>
                                    <v-text-field v-model="username" prepend-icon="person" name="login" label="Όνομα χρήστη" type="text"></v-text-field>
                                    <v-text-field  v-model="password" id="password" prepend-icon="lock" name="password" label="Κωδικός" type="password"></v-text-field>
                                </v-form>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="login()" color="primary">Σύνδεση</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-alert
                        :value="error"
                        type="error"
                >
                    {{error}}
                </v-alert>
            </v-container>
        </v-content>
    </template>
<script>
    import ApiData from '@/assets/ApiData'
    import router from "../router";
    import StoreState from "@/assets/StoreState";


    export default {
        name: "Login",
        data:function () {
            return {
                password:"",
                username:"",
                error:"",
                storeState: StoreState.api
            }
        },
        methods:{
          login(){
                  ApiData.loginToAdmin(this.password, this.username).then(
                      resp=>{
                          if (resp.data === "error"){
                                this.error = "Δεν ήταν δυνατή η σύνδεση"
                          }else{
                              StoreState.setAuthCookie(resp.data);
                              ApiData.resetApi();
                              router.push("/")
                          }
                      }
                  )
          }
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Login.vue